import module from 'app/module.js'
import { noop } from 'lodash'

const localhost = (/^(localhost|192\.168\.\d{1,3}\.\d{1,3})$/).test(window.location.hostname)

if (!localhost) window.console.debug = noop

module.constant('CONSTANTS', {
    TIME_FORMAT_LONG: 'EEEE, MMMM d, y @ h:mm:ss a',
    DATE_FORMAT_LONG: 'EEEE, MMMM d, y',
    DATE_FORMAT: 'MMM d, y',
  })
  .constant('ENV', {
    debugMode: localhost,
  })



// WEBPACK FOOTER //
// ./src/app/config.js